import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import * as _ from 'lodash';

import {AuthenticationService} from '../services/authentication.service';

@Injectable()
export class AuthorizationService {
  user: any = {};

  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) {
    this.user = this.authService.getUser();
  }

  assertAccessibility(permission: string) {
    const permissions = _.isEmpty(this.user) ? [] : this.user.permissions;

    if (!permissions.includes(permission)) {
      this.router.navigate(['error', 403]);
    }
  }

  hasAccess(permission: string) {
    const permissions = _.isEmpty(this.user) ? [] : this.user.permissions;

    return permissions.includes(permission);
  }
}
